import api from "../../../api/comptabilite/_operations";

const state = () => ({
    operation: [],
    operations: [],
    operationUserCompte: [],
    compteOperation: false,
    solde_disponible: 0,
    solde_du_jour: 0,
    journal_caisse: [],
    journal_tresorier: [],
    solde_tresorier: 0,

    solde_compte_depot: 0,
    solde_compte_depense: 0,
    solde_restant_ligne_budgetaire: 0,

    liste_coupons: [],
    liste_reliquats: [],
    operations_caisse: [],
    liste_demandes_annulation: [],

    liste_produits_creances: [],
    liste_charges_exploitation: [],
    liste_operations_patient: [],
    bill_selected_operations: [],
    selected_sfe_aib: {},
    paying_bill_state: '',
    is_paid: false,

    liste_factures: [],
    selected_facture: [],

    operations_rembourse_assurance: [],
    factures_assurance: [],
    selected_insurance_bill: {},
    // operations_en_attente: [],
    selected_patient_attente: {},

    sale_receipts: [],
    discount_number: 0,
    global_discount_number: 0,
    discount_observer: 0,

    global_cancellation_request: 0,
    cancellation_observer: 0,

    bons_consultation_factures: [],
    new_storage:[],
    payment_action: '',
});

// getters
const getters = {
    operationStored: (state) => {
        return state.operation;
    },

    operationUserCompte: (state) => {
        return state.operationUserCompte;
    },

    solde_disponible: (state) => {
        return state.solde_disponible;
    },

    solde_du_jour: (state) => {
        return state.solde_du_jour;
    },

    journal_caisse: (state) => {
        return state.journal_caisse;
    },

    journal_tresorier: (state) => {
        return state.journal_tresorier;
    },

    solde_tresorier: (state) => {
        return state.solde_tresorier;
    },

    solde_compte_depot: (state) => {
        return state.solde_compte_depot;
    },

    solde_compte_depense: (state) => {
        return state.solde_compte_depense;
    },

    solde_restant_ligne_budgetaire: (state) => {
        return state.solde_restant_ligne_budgetaire;
    },

    liste_coupons: (state) => {
        return state.liste_coupons;
    },

    liste_reliquats: (state) => {
        return state.liste_reliquats;
    },

    operations_caisse: (state) => {
        return state.operations_caisse;
    },

    liste_demandes_annulation: (state) => {
        return state.liste_demandes_annulation;
    },

    liste_produits_creances: (state) => {
        return state.liste_produits_creances;
    },

    liste_charges_exploitation: (state) => {
        return state.liste_charges_exploitation;
    },

    liste_operations_patient: (state) => {
        return state.liste_operations_patient;
    },

    bill_selected_operations: (state) => {
        return state.bill_selected_operations;
    },
    
    selected_sfe_aib: (state) => {
        return state.selected_sfe_aib;
    },

    paying_bill_state: (state) => {
        return state.paying_bill_state;
    },

    is_paid: (state) => {
        return state.is_paid;
    },

    liste_factures: (state) => {
        return state.liste_factures;
    },

    selected_facture: (state) => {
        return state.selected_facture;
    },

    operations_rembourse_assurance: (state) => {
        return state.operations_rembourse_assurance;
    },

    factures_assurance: (state) => {
        return state.factures_assurance;
    },

    selected_insurance_bill: (state) => {
        return state.selected_insurance_bill;
    },

    // operations_en_attente: (state) => {
    //     return state.operations_en_attente;
    // },

    selected_patient_attente: (state) => {
        return state.selected_patient_attente;
    },

    sale_receipts: (state) => {
        return state.sale_receipts;
    },

    discount_number: (state) => {
        return state.discount_number;
    },
    
    global_discount_number: (state) => {
        return state.global_discount_number;
    },

    discount_observer: (state) => {
        return state.discount_observer;
    },

    global_cancellation_request: (state) => {
        return state.global_cancellation_request;
    },

    cancellation_observer: (state) => {
        return state.cancellation_observer;
    },
    
    bons_consultation_factures: (state) => {
        return state.bons_consultation_factures;
    },

    payment_action: (state) => {
        return state.payment_action;
    },
};
// mutations
const mutations = {
    SET_OPERATION(state, operation) {
        state.operation = operation;
    },

    SET_OPERATIONS(state, operations) {
        state.operations = operations;
    },

    SET_COMPTE_OPERATION(state, etat) {
        state.compteOperation = etat;
    },

    SET_OPERATION_USER_COMPTE(state, etat) {
        state.operationUserCompte = etat;
    },

    ADD_OPERATION_USER_COMPTE(state, etat) {
        state.operationUserCompte.push(etat);
    },

    SET_SOLDE_DISPONIBLE(state, solde) {
        state.solde_disponible = solde;
    },

    SET_SOLDE_DU_JOUR(state, solde) {
        state.solde_du_jour = solde;
    },

    SET_JOURNAL_CAISSE(state, solde) {
        state.journal_caisse = solde;
    },

    SET_JOURNAL_TRESORIER(state, solde) {
        state.journal_tresorier = solde;
    },

    SET_SOLDE_TRESORIER(state, solde) {
        state.solde_tresorier = solde;
    },

    SET_SOLDE_COMPTE_DEPOT(state, solde) {
        state.solde_compte_depot = solde;
    },

    SET_SOLDE_COMPTE_DEPENSE(state, solde) {
        state.solde_compte_depense = solde;
    },

    SET_SOLDE_RESTANT_LIGNE_BUDGETAIRE(state, solde) {
        state.solde_restant_ligne_budgetaire = solde;
    },

    SET_LISTE_COUPONS(state, coupons) {
        state.liste_coupons = coupons;
    },

    SET_LISTE_RELIQUATS(state, solde) {
        state.liste_reliquats = solde;
    },

    SET_OPERATIONS_CAISSE(state, operations) {
        state.operations_caisse = operations;
    },

    SET_LISTE_DEMANDES_ANNULATION(state, demandes) {
        state.liste_demandes_annulation = demandes;
    },

    SET_LISTE_PRODUITS_CREANCES(state, liste) {
        state.liste_produits_creances = liste;
    },

    SET_LISTE_CHARGES_EXPLOITATION(state, charges) {
        state.liste_charges_exploitation = charges;
    },

    SET_LISTE_OPERATIONS_PATIENT(state, operations) {
        state.liste_operations_patient = operations;
    },

    SET_BILL_SELECTED_OPERATIONS(state, operation) {
        state.bill_selected_operations = operation;
    },
    
    SET_SELECTED_SFE_AIB(state, operation) {
        state.selected_sfe_aib = operation;
    },
    
    SET_PAYING_BILL_STATE(state, operation) {
        state.paying_bill_state = operation;
    },

    SET_IS_PAID(state, status) {
        state.is_paid = status;
    },

    SET_LISTE_FACTURES(state, liste) {
        state.liste_factures = liste;
    },

    SET_SELECTED_FACTURE(state, facture) {
        state.selected_facture = facture;
    },

    SET_OPERATIONS_REMBOURSE_ASSURANCE(state, operations) {
        state.operations_rembourse_assurance = operations;
    },

    SET_FACTURES_ASSURANCE(state, operations) {
        state.factures_assurance = operations;
    },

    SET_SELECTED_INSURANCE_BILL(state, operations) {
        state.selected_insurance_bill = operations;
    },

    // SET_OPERATIONS_EN_ATTENTE(state, operations) {
    //     state.operations_en_attente = operations;
    // },

    SET_SELECTED_PATIENT_ATTENTE(state, operations) {
        state.selected_patient_attente = operations;
    },

    SET_SALE_RECEIPTS(state, receipts) {
        state.sale_receipts = receipts;
    },

    SET_DISCOUNT_NUMBER(state, count) {
        state.discount_number = count;
    },
    
    SET_GLOBAL_DISCOUNT_NUMBER(state, count) {
        state.global_discount_number = count;
    },

    SET_DISCOUNT_OBSERVER(state, observer) {
        state.discount_observer = observer;
    },

    SET_GLOBAL_CANCELLATION_REQUEST(state, count) {
        state.global_cancellation_request = count;
    },

    SET_CANCELLATION_OBSERVER(state, observer) {
        state.cancellation_observer = observer;
    },
    
    SET_BONS_CONSULTATION_FACTURES(state, bon) {
        state.bons_consultation_factures = bon;
    },

    SET_PAYMENT_ACTION(state, action) {
        state.payment_action = action;
    },
};

// actions
const actions = {
    storeOperation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.storeOperation(data).then(
                (response) => {
                    commit("SET_OPERATION", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    storeReliquat({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.storeReliquat(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    // TODO : DELETE
    getOperations({ commit }) {
        return new Promise((resolve, reject) => {
            api.getOperations().then(
                (response) => {
                    commit("SET_OPERATIONS", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getAnOperation({ commit }, idOp) {
        return new Promise((resolve, reject) => {
            api.getAnOperation(idOp).then(
                (response) => {
                    commit("SET_OPERATION", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    updateExistingOperation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.updateExistingOperation(data).then(
                (response) => {
                    commit("SET_OPERATION", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    
    confirmVersementReception({ commit }, idOp) {
        return new Promise((resolve, reject) => {
            api.confirmVersementReception(idOp).then(
                (response) => {
                    commit;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getVersementsEnAttenteByCompte({ commit }, idCompte) {
        return new Promise((resolve, reject) => {
            api.getVersementsEnAttenteByCompte(idCompte).then(
                (response) => {
                    commit;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getTotauxByDateUserCompte({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getTotauxByDateUserCompte(data.date, data.idUser, data.idCompte).then(
                (response) => {
                    // commit("SET_OPERATIONS", response);
                    commit;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getCarnetsDetailsPerOperation({ commit }, idOperation) {
        return new Promise((resolve, reject) => {
            api.getCarnetsDetailsPerOperation(idOperation).then(
                (response) => {
                    // commit("SET_OPERATIONS", response);
                    commit;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    storeCompteOperation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.storeCompteOperation(data.compte, data.operation).then(
                (response) => {
                    commit("SET_COMPTE_OPERATION", true);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    storeLigneSortieDeCaisse({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.storeLigneSortieDeCaisse(data).then(
                (response) => {
                    let date = new Date(response.created_at)
                    let month = date.getMonth() + 1
                    let only_date = date.getDate() + '/' + month + '/' + date.getFullYear()

                    let hr = date.getHours()
                    hr = (hr < 10)?'0'+hr:hr

                    let min = date.getMinutes()
                    min = (min < 10)?'0'+min:min

                    let only_hour = hr + 'h' + min
                    // let only_hour = date.getHours() + ':' + date.getMinutes()

                    let to_return = {
                        idOp: response.id,
                        Dates: only_date,
                        Heures: only_hour,
                        Libelle: response.libelle,
                        Sorties: new Number(Math.round(response.montant)).toLocaleString("fr-FR"),
                        Entrées: 0,
                        versement_confirm: response.versement_confirm,
                        type_operation: response.type_operation,
                        commentaire_sortie_caisse: response.commentaire_sortie_caisse,
                        nom_prenoms: '-'
                    };
                    commit("ADD_OPERATION_USER_COMPTE", to_return);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getLignesDepensesByIdOp({ commit }, idOp) {
        return new Promise((resolve, reject) => {
            api.getLignesDepensesByIdOp(idOp).then(
                (response) => {
                    commit;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getSoldeDisponible({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getSoldeDisponible(data).then(
                (response) => {
                    commit("SET_SOLDE_DISPONIBLE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getSoldeDuJour({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getSoldeDuJour(data).then(
                (response) => {
                    commit("SET_SOLDE_DU_JOUR", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    /**
     * Enregistrer paiement dette patient
     * @param {*} param0 
     * @param {*} data 
     */
    storePaiementDettePatient({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.storePaiementDette(data.dette).then((response) => {
                let date = new Date(response.created_at)
                let only_date = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
                let hr = date.getHours()
                hr = (hr < 10)?'0'+hr:hr

                let min = date.getMinutes()
                min = (min < 10)?'0'+min:min

                let only_hour = hr + 'h' + min
                // let only_hour = date.getHours() + ':' + date.getMinutes()

                let to_return = {
                    idOp: response.id,
                    Dates: only_date,
                    Heures: only_hour,
                    Libelle: response.libelle,
                    Sorties: 0,
                    Entrées: new Number(Math.round(response.montant)).toLocaleString("fr-FR"),
                    versement_confirm: response.versement_confirm,
                    type_operation: response.type_operation,
                    commentaire_sortie_caisse: response.commentaire_sortie_caisse,
                    nom_prenoms: response.patient
                };
                commit("ADD_OPERATION_USER_COMPTE", to_return);
                resolve(response);
            }, 
            (error) => {
                reject(error);
            })
        })
    },

    getJournalCaisse({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getJournalCaisse(data).then(
                (response) => {
                    commit("SET_JOURNAL_CAISSE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveProvision({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveProvision(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getJournalTresorier({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getJournalTresorier(data).then(
                (response) => {
                    commit("SET_JOURNAL_TRESORIER", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getSoldeTresorier({ commit }, compte_id) {
        return new Promise((resolve, reject) => {
            api.getSoldeTresorier(compte_id).then(
                (response) => {
                    commit("SET_SOLDE_TRESORIER", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    confirmerVersement({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.confirmerVersement(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getSoldeCourantCompteDepot({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getSoldeCourantCompteDepot(data).then(
                (response) => {
                    commit("SET_SOLDE_COMPTE_DEPOT", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getSoldeCourantCompteDepense({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getSoldeCourantCompteDepense(data).then(
                (response) => {
                    commit("SET_SOLDE_COMPTE_DEPENSE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getSoldeCourantLigneBudgetaire({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getSoldeCourantLigneBudgetaire(data).then(
                (response) => {
                    commit("SET_SOLDE_RESTANT_LIGNE_BUDGETAIRE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeReliquats({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeReliquats(data).then(
                (response) => {
                    commit("SET_LISTE_RELIQUATS", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    reglerReliquat({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.reglerReliquat(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    storeOperationCaisse({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.storeOperationCaisse(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    updateOperationCaisse({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.updateOperationCaisse(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getOperationsCaisse({ commit }, data) {
        commit("SET_OPERATIONS_CAISSE", [])
        return new Promise((resolve, reject) => {
            api.getOperationsCaisse(data).then(
                (response) => {
                    commit("SET_OPERATIONS_CAISSE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    storeDemandeAnnulation({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.storeDemandeAnnulation(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeDemandeAnnulation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeDemandeAnnulation(data).then(
                (response) => {
                    commit("SET_LISTE_DEMANDES_ANNULATION", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    validerDemandeAnnulation({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.validerDemandeAnnulation(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeCoupons({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeCoupons(data).then(
                (response) => {
                    commit("SET_LISTE_COUPONS", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeProduitsCreances({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeProduitsCreances(data).then(
                (response) => {
                    commit("SET_LISTE_PRODUITS_CREANCES", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeChargesExploitation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeChargesExploitation(data).then(
                (response) => {
                    commit("SET_LISTE_CHARGES_EXPLOITATION", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeOperationsPatient({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeOperationsPatient(data).then(
                (response) => {
                    commit("SET_LISTE_OPERATIONS_PATIENT", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    generateBill({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.generateBill(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    standardizeInvoice({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.standardizeInvoice(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeFacture({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeFacture(data).then(
                (response) => {
                    commit("SET_LISTE_FACTURES", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    generateInsuranceBill({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.generateInsuranceBill(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeFactureAssurance({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeFactureAssurance(data).then(
                (response) => {
                    commit('SET_FACTURES_ASSURANCE', response)
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getOpertaionsEnAttente({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getOpertaionsEnAttente(data).then(
                (response) => {
                    commit('SET_OPERATIONS_EN_ATTENTE', response)
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeTicketCaisse({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeTicketCaisse(data).then(
                (response) => {
                    commit('SET_SALE_RECEIPTS', response)
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    countDiscount({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.countDiscount(data).then(
                (response) => {
                    if (data.is_all) {
                        commit('SET_GLOBAL_DISCOUNT_NUMBER', response)
                    } else {
                        commit('SET_DISCOUNT_NUMBER', response)
                    }
                    
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    updateViewedDiscount({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.updateViewedDiscount(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    countCancellationRequest({ commit }) {
        return new Promise((resolve, reject) => {
            api.countCancellationRequest().then(
                (response) => {
                    commit('SET_GLOBAL_CANCELLATION_REQUEST', response)
                    
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveVentePrestation({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveVentePrestation(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    deleteVentePrestation({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteVentePrestation(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveProforma({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveProforma(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    updateOperationAttente({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.updateOperationAttente(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    cancelInvoice({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.cancelInvoice(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    /**
     * Annulation d'une Facture de remboursement assurance
     * @param {*} param0 
     * @param {*} data 
     * @returns 
     */
    cancelPayBackInvoice({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.cancelPayBackInvoice(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveVersementBanque({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveVersementBanque(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },  
};

export default {
    state,
    getters,
    mutations,
    actions,
};